export default __webpack_public_path__ + "static/N0012-1cb6f51c4657085d8e4e826f92b00389.png";